import apiUtils from '@utils/apiUtils';
import { fetchAPI } from './apiServiceHelper';
import { apiConstants } from '../utils/constants';

const defaultGetParam = apiUtils.getDefaultGetParams();

let api = {
    tmHotelReconciliation: {
        get: ({
            offset = defaultGetParam.offset,
            limit = defaultGetParam.limit,
            filter,
            sort = '',
            orderTypes = 'PRE_BUNDLE',
        }) => {
            return fetchAPI.getList(
                `${apiConstants.BASE_URL}/api/order/report/reconciliation/tm`,
                apiUtils.normalizeQueryParams({
                    ...filter,
                    limit,
                    offset,
                    sort,
                    orderTypes,
                })
            );
        },
    },
};

export default api;
